import { z } from 'zod';

const priceSchema = z.object({ amount: z.coerce.number().int(), currency: z.string() });

export const planSchema = z.object({
  amount: z.coerce.number().int(),
  app_identity: z.object({ value: z.string() }),
  benefits: z.array(
    z.object({
      title: z.record(z.string(), z.string()),
      icon_url: z.string(),
    }),
  ),
  best_price: z.boolean(),
  countries_access_type: z.enum(['common', 'whitelist', 'blacklist']),
  countries_iso_codes: z.array(z.string()),
  credit_to_apply_on_wallet: z.coerce.number().int(),
  currency: z.string(),
  data: z.object({
    coupon_discount_amount: priceSchema,
    discount: z.record(z.string(), z.string()),
    discount_amount_in_currency: priceSchema,
    full_price_after_discount: priceSchema,
    full_price_before_discount: priceSchema,
    initial_price_per_month: priceSchema.nullable(),
    initial_total_order_amount: priceSchema.nullable(),
    price_description: z.record(z.string(), z.string()),
    price_description_detailed: z.record(z.string(), z.string()),
    price_per_month: priceSchema,
    subtitle: z.record(z.string(), z.string()),
    title: z.record(z.string(), z.string()),
    total_order_amount: priceSchema,
    total_savings: priceSchema,
  }),
  duration: z.coerce.number().int(), // hours
  enabled: z.boolean(),
  has_trial: z.boolean(),
  id: z.string(),
  index: z.coerce.number().int(),
  name: z.string(),
  product_type: z.enum(['subscription']),
  sku: z.string(),
  taxes: z.array(
    z.object({
      amount: z.coerce.number().int(),
      name: z.string(),
      description: z.string(),
    }),
  ),
  trial_period_in_days: z.coerce.number().int(),
  version_filter_pattern: z.string().optional(),
});

export type BackendProduct = z.infer<typeof planSchema>;

export const planReponseSchema = z.object({ products: z.array(planSchema).nonempty() });
export type PlansAPIResponse = z.infer<typeof planReponseSchema>;
